import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import GradientWrapper from '../GradientBox/GradientWrapper';
const openDelay = 0.14;
const closeDelay = 0.06;
// in sync with css
const closeDuration = 0.3;
const MaskedText = ({ idx, isOpen, text }) => {
    const [open, setOpen] = useState(false);
    const [showGradient, setShowGradient] = useState(false);
    const timeout = useRef(0);
    const gradientTimeout = useRef(0);
    const sliderRef = useRef(null);
    const contentRef = useRef(null);
    const mounted = useRef(false);
    /* useEffect(() => {
      const openDuration = 0.4;
      const closeDuration = 0.3;
      const openEase = 'power2.inOut';
      const closeEase = 'power2.inOut';
      
      if (sliderRef.current && contentRef.current && mounted.current) {
        gsap.killTweensOf(sliderRef.current);
        gsap.killTweensOf(contentRef.current);
        let sliderX = '0%';
        let contentX = '0%';
        if (!open) {
          sliderX = '-100%';
          contentX = '100%';
        }
        gsap.to(sliderRef.current, {
          duration: open ? openDuration : closeDuration,
          ease: open ? openEase : closeEase,
          x: sliderX,
        });
        gsap.to(contentRef.current, {
          duration: open ? openDuration : closeDuration,
          ease: open ? openEase : closeEase,
          x: contentX,
        });
      }
    }, [open]); */
    useEffect(() => {
        clearTimeout(gradientTimeout.current);
        if (open) {
            setShowGradient(true);
        }
        else {
            gradientTimeout.current = window.setTimeout(() => setShowGradient(false), closeDuration * 1000);
        }
    }, [open]);
    useEffect(() => {
        clearTimeout(timeout.current);
        if (isOpen) {
            timeout.current = window.setTimeout(() => setOpen(true), idx * openDelay * 1000 + 10);
        }
        else {
            timeout.current = window.setTimeout(() => setOpen(false), idx * closeDelay * 1000);
        }
        mounted.current = true;
    }, [isOpen]);
    return (_jsx("div", { className: `fixed-container-line${open ? ' open' : ''}`, children: _jsx("div", { className: "fixed-container-line-slider", ref: sliderRef, children: _jsxs("div", { className: "fixed-container-line-content", ref: contentRef, children: [_jsx(GradientWrapper, { active: showGradient }), text] }) }) }));
};
export default MaskedText;
